import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    contentTag: String
  }

  async copy () {
    try {
      const content = document.querySelector(`[id*='${this.contentTagValue}']`)
      await navigator.clipboard.writeText(content?.value);
      const spanTag = this.element
      const previousContent = spanTag.innerHTML
      spanTag.innerHTML = 'Copied!'
      setTimeout(() => spanTag.innerHTML = previousContent, 2000)
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };
}
